module.exports = __webpack_public_path__ + "static/img/img14.5f4816e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img14.gif
// module id = TS3A
// module chunks = 2